import React, { useState, useEffect, useRef } from 'react';
import DefaultModal from 'components/Modal/DefaultModal';
import { Row, Col, InputGroup, Input, InputGroupAddon } from 'reactstrap';

import ModalFilterClients from '../components/ModalFilterClients';
import ReactButton from 'components/Buttons/ReactButton';
import ReactLoader from 'components/Loader';
import { TableContainer } from './style';
import CreateContactModal from '../CreateContactModal/index';
import ContactService from '../service/index';
import Pagination from 'components/Pagination';
import TemplatesModal from '../TemplatesModal/index';
import { toast } from 'react-toastify';
import ModalConfirmation from '../../../../../../../components/Modal/ConfirmationModal';
import useDebounce from './hooks/useDebaunce';
import { isNaN } from 'lodash';
import MultiContactsModal from './components/multiContactsTable';
import { RiUserSearchLine } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import { IoSearch } from 'react-icons/io5';
import { AiOutlineUserAdd } from 'react-icons/ai';

const ContactActiveModal = ({ show, onModalToggle, ...props }) => {
  const [createContactModalVisbility, setCreateContactModalVisbility] =
    useState(false);
  const [initMultiContactModal, setInitMultiContactModal] = useState(false);
  const [modalConversationVisbility, setModalConversationVisbility] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const [isClientSearchModalOpen, setIsClientSearchModalOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);

  const limitOfContactsPerPage = 10;

  const [filterByName, setFilterByName] = useState('');
  const [filterByTelephone, setFilterByTelephone] = useState('');
  const [filterByEmail, setFilterByEmail] = useState('');

  const [contacts, setContacts] = useState([]);

  const [clientNumber, setClientNumber] = useState();
  const [clientDDI, setClientDDI] = useState();
  const [clientId, setClientId] = useState();
  const [contactId, setContactId] = useState();
  const [clientName, setClientName] = useState();

  const [searchValue, setSearchValue] = useState('');

  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [idResource, setIdResource] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const dropdownRef = useRef(null);

  const debouncedSearchValue = useDebounce(searchValue, 1000);

  const [searchHistory, setSearchHistory] = useState(() => {
    const savedHistory = localStorage.getItem('searchHistory');
    return savedHistory ? JSON.parse(savedHistory) : [];
  });

  useEffect(() => {
    if (show) setInitMultiContactModal(false);
  }, [show]);

  useEffect(() => {
    if (debouncedSearchValue.trim() !== '') {
      setSearchHistory((prevHistory) => {
        const newHistory = prevHistory.filter(
          (item) => item !== debouncedSearchValue
        );
        return [debouncedSearchValue, ...newHistory].slice(0, 10);
      });
    }
  }, [debouncedSearchValue]);

  useEffect(() => {
    setSelectedRows([]);
  }, []);

  useEffect(() => {
    localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
  }, [searchHistory]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const searchContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchValue.length === 0 || !searchValue.length) {
      setPage(1);
      setFilterByName('');
      setFilterByTelephone('');
      setFilterByEmail('');
      return;
    }

    const defaultFieldNames = ['nome', 'telefone', 'email'];
    const textFilter = [...defaultFieldNames].map((fieldName) => ({
      [fieldName]: searchValue
    }));
    const fieldsToFilter = [...textFilter];

    const filters = {};
    fieldsToFilter.forEach((filter) => {
      Object.assign(filters, filter);
    });

    const filtersDTO = {};
    const filtersDTOAllContacts = {};
    for (const key in filters) {
      const value = filters[key];
      if (value) {
        filtersDTO[key] = value;
        filtersDTOAllContacts[key] = value;
      }
    }
    const isNotANumber = isNaN(parseInt(filtersDTOAllContacts.telefone));

    if (isNotANumber) {
      filtersDTOAllContacts.telefone = '';
    } else {
      filtersDTOAllContacts.nome = '';
    }

    setFilterByName(filtersDTOAllContacts.nome);
    setFilterByTelephone(filtersDTOAllContacts.telefone);
    setFilterByEmail(filtersDTOAllContacts.email);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue]);

  useEffect(() => {
    async function goToFistPage() {
      setPage(1);
    }
    goToFistPage();
  }, [filterByName, filterByTelephone, filterByEmail, debouncedSearchValue]);

  useEffect(() => {
    setLoading(true);
    getAllContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    filterByName,
    filterByTelephone,
    filterByEmail,
    isClientSearchModalOpen,
    show,
    createContactModalVisbility
  ]);

  useEffect(() => {
    setFilterByTelephone('');
    setFilterByName('');
    setSearchValue('');
    setFilterByEmail('');
  }, [show]);

  const getAllContacts = () => {
    ContactService.getContacts({
      page,
      name: filterByName.includes('@') ? '' : filterByName,
      telephone: filterByTelephone,
      email: filterByEmail.includes('@') ? filterByEmail : ''
    })
      .then((response) => {
        if (response.data.registers === null) {
          setCount(response.data.count);
          setContacts([]);
        } else {
          setCount(response.data.count);
          setContacts(response.data.registers);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro na consulta =>', error);
        toast.error('Erro ao buscar contatos');
        setLoading(false);
      });
  };

  async function handleSelectcontact(contact) {
    setContactId(contact.id);
    setClientDDI(contact.client_ddi);
    setClientNumber(contact.client_phone);
    setModalConversationVisbility(!modalConversationVisbility);
  }

  async function handleSelectMultiContact() {
    setModalConversationVisbility(!modalConversationVisbility);
  }

  const controlDelete = (contactId) => {
    setOpenModalConfirmation(true);
    setIdResource(contactId);
  };

  const deleteContact = async (contactId) => {
    try {
      const deleted = await ContactService.deleteContact(contactId);
      toast.success(deleted.data.message || 'Contato deletado com sucesso', {
        autoClose: 3000,
        closeOnClick: true
      });
    } catch (err) {
      console.log(err);
      const message =
        (err.response && err.response.data && err.response.data.message) ||
        'Erro ao deletar contato';
      toast.error(message, {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setOpenModalConfirmation(false);
      getAllContacts();
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows((prevSelectedRows) => {
        const isAlreadySelected = prevSelectedRows.some(
          (x) => x.id === row.id || x.client_id === row.client_id
        );
        if (!isAlreadySelected) {
          return [...prevSelectedRows, row];
        }
        return prevSelectedRows;
      });
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter(
          (x) => x.id !== row.id && x.client_id !== row.client_id
        )
      );
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedRows((prevSelectedRows) => {
        const uniqueRows = [...prevSelectedRows];

        rows.forEach((row) => {
          const isAlreadySelected = uniqueRows.some(
            (x) => x.id === row.id || x.client_id === row.client_id
          );
          if (!isAlreadySelected) {
            uniqueRows.push(row);
          }
        });

        return uniqueRows;
      });
    } else {
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    if (searchValue.trim() === '') {
      setFilteredHistory(searchHistory);
    } else {
      const filtered = searchHistory.filter((item) =>
        item.toLowerCase().startsWith(searchValue.toLowerCase())
      );
      setFilteredHistory(filtered);
    }
  }, [searchValue, searchHistory]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const [buttonSearchHover, setButtonSearchHover] = useState(false);

  return (
    <DefaultModal
      show={show}
      onModalToggle={onModalToggle}
      title="Buscar Contato"
      subtitle={`Total de contatos ${count}`}
      showCloseButton={false}
      modalContainerClasses="modal-lg"
      {...props}
    >
      <Row>
        <Col>
          <div style={{ position: 'relative' }} ref={dropdownRef}>
            <InputGroup
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <Input
                bsSize="md"
                placeholder="Buscar contatos..."
                type="text"
                value={searchValue}
                onChange={(event) => {
                  setSearchValue(event.target.value);
                  setDropdownOpen(event.target.value.trim() !== '');
                }}
                onClick={() => setDropdownOpen(true)}
                onFocus={() => setDropdownOpen(true)}
                style={{
                  padding: '1rem 3rem 1rem 1rem',
                  border: '0.05rem solid lightgray',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  width: '100%',
                  outline: 'none',
                  transition: 'box-shadow 0.3s ease',
                  color: '#33333380',
                  fontWeight: '500'
                }}
              />
              <div
                style={{
                  backgroundColor: systemConfiguration.primary_color || 'gray',
                  borderRadius: '0.5rem',
                  padding: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '32px',
                  width: '32px',
                  right: '5.35rem',
                  cursor: 'pointer',
                  transition: 'opacity 0.3s ease',
                  marginLeft: '-3rem',
                  zIndex: 3,
                  opacity: buttonSearchHover ? 1 : 0.8
                }}
                onMouseEnter={() => setButtonSearchHover(true)}
                onMouseLeave={() => setButtonSearchHover(false)}
              >
                <IoSearch size={20} color="#fff" />
              </div>
              {!initMultiContactModal && (
                <InputGroupAddon addonType="append">
                  <ReactButton
                    onClick={() => setIsClientSearchModalOpen(true)}
                    btnColor="primary"
                    style={{
                      background: systemConfiguration.primary_color,
                      color: '#fff',
                      borderRadius: '5px',
                      border: 'none',
                      height: '45px',
                      marginLeft: '1rem'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                    >
                      <RiUserSearchLine size={16} />
                      Busca Avançada
                    </div>
                  </ReactButton>
                </InputGroupAddon>
              )}
            </InputGroup>

            {filteredHistory.length > 0 && dropdownOpen && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  marginLeft: '1rem'
                }}
              >
                {filteredHistory.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setSearchValue(item);
                      setDropdownOpen(false);
                    }}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee'
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = '#f5f5f5')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = '#fff')
                    }
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Col>
      </Row>

      <TableContainer style={{ overflowX: 'auto' }}>
        {loading ? (
          <Row className="justify-content-md-center py-3">
            <ReactLoader />
          </Row>
        ) : (
          <MultiContactsModal
            contacts={contacts}
            handleOnSelect={handleOnSelect}
            handleOnSelectAll={handleOnSelectAll}
            selectedRows={selectedRows}
            initMultiContactModal={initMultiContactModal}
            page={page}
            limitOfContactsPerPage={limitOfContactsPerPage}
            handleSelectcontact={handleSelectcontact}
            controlDelete={controlDelete}
          />
        )}
        <Pagination
          activePage={page}
          totalItemsCount={count}
          onChange={handlePageChange.bind(this)}
        />
      </TableContainer>

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <ReactButton
          onClick={() => {
            setCreateContactModalVisbility(!createContactModalVisbility);
          }}
          btnColor="primary"
        >
          <AiOutlineUserAdd size={16} /> Adicionar novo contato
        </ReactButton>
        <ReactButton
          onClick={() => {
            setInitMultiContactModal(!initMultiContactModal);
            setSelectedRows([]);
          }}
          btnColor="secondary"
        >
          {initMultiContactModal
            ? 'Iniciar uma conversa'
            : 'Iniciar várias conversas'}
        </ReactButton>
        {initMultiContactModal && selectedRows.length > 0 ? (
          <ReactButton
            onClick={() => {
              handleSelectMultiContact();
            }}
            btnColor="secondary"
          >
            Escolher template
          </ReactButton>
        ) : null}
      </div>

      <TemplatesModal
        show={modalConversationVisbility}
        onModalToggle={setModalConversationVisbility}
        clientNumber={clientNumber}
        clientDDI={clientDDI}
        contactId={contactId}
        clientId={clientId}
        clientName={clientName}
        showCloseButton={false}
        isIsolated={contactId ? false : true}
        selectedContacts={selectedRows}
        setSelectedContacts={setSelectedRows}
        isMultiContact={initMultiContactModal}
      />
      <CreateContactModal
        className="modal-lg"
        show={createContactModalVisbility}
        onModalToggle={setCreateContactModalVisbility}
      ></CreateContactModal>

      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteContact}
        message={'Tem certeza que deseja excluir este contato?'}
      />
      <ModalFilterClients
        className="modal-lg"
        show={isClientSearchModalOpen}
        onModalToggle={setIsClientSearchModalOpen}
        setSelectedClient={(a) => {
          setClientNumber(a.clientPhone);
          setClientDDI(a.clientDdi);
          setClientId(a.clientId);
          setClientName(a.clientName);
          setSelectedRows((prevSelectedRows) => {
            const alreadyExists = prevSelectedRows.some(
              (row) => row.client_id === a.clientId
            );
            const newRows = alreadyExists
              ? prevSelectedRows
              : [
                  ...prevSelectedRows,
                  {
                    client_id: a.clientId,
                    client_name: a.clientName,
                    client_phone: a.clientPhone,
                    ddi: a.clientDdi
                  }
                ];

            return newRows;
          });
        }}
        handleSelectMultiContact={handleSelectMultiContact}
        setInitMultiContactModal={setInitMultiContactModal}
        setSelectedRows={setSelectedRows}
      />
    </DefaultModal>
  );
};

export default ContactActiveModal;
